<template>
  <div v-if="chartReady && loader" class="chart-container" id="graphChart">
    <slot></slot>
    <!-- <v-container v-if="this.visualization.component == null || (this.visualization.component != null && !this.visualization.component.includes('RadarChart'))" style="display: flex; flex-direction: row; justify-content: center; align-items: center;" color="bg-primary">
      <span style="display: flex; justify-content: center; align-items: center; flex-direction: column; border: 2px solid black; border-radius: 20px; width: max-content; padding: 0 10px; margin: 0 15px;">
        <p style="transform: translateY(50%);">Sélection <br> Multiple</p>
        <v-switch
            v-model=selectionMode
            color="primary"
            v-on:change=setSelectionMode()
        />
      </span>
    </v-container> -->
    <template v-if="this.$store.state.profile.user.role === 'srAdmin'" >
      <v-text-field v-model="custN" @keyup.enter="logVariableByName(custN)" placeholder="Variable name to search for"></v-text-field>
      <v-textarea readonly v-model="custNLog"></v-textarea>
    </template>
    <RadarChart v-if="isRadarVisualization()" :chartData="chartData" :options="chartOptions" />
    <DoughnutChart v-else-if="isDonutVisualization()" :chartData="chartData" :options="chartOptions" />
    <PieChart v-else-if="isPieVisualization()" :chartData="chartData" :options="chartOptions" />
    <PolarAreaChart v-else-if="isPolarAreaVisualization()" :chartData="chartData" :options="chartOptions" />
    <ScatterChart v-else-if="isScatterVisualization()" :chartData="chartData" :options="chartOptions" />
    <BubbleChart v-else-if="isBubbleVisualization()" :chartData="chartData" :options="chartOptions" />
    <Bar v-else :chartData="chartData" :options="chartOptions" ref="mainChartRef" />
    <!--<v-btn @click.stop="reloadAnimation"></v-btn>-->
  </div>
  <div v-else class="chart-container text-center">
    <slot></slot>
    <v-progress-circular indeterminate></v-progress-circular>
  </div>
</template>
<script>
import Bar from "./Charts/Bar";
//import chartJsPluginAnnotation from "chartjs-plugin-annotation";

import {
  dateFormatFrenchPretty,
  getDates,
  convertDate,
  toDate,
  convertDatePickerToDate,
  convertDateToStringWithMinutes,
  convertDateFullRange,
} from "@/utils/dates";
import { getRandomColor, getAlteredColor } from "@/utils/colors";
import { getColor } from "@/const/stadepheno";
import {
  buildTimeRangeQuery, buildQueryMust, applyDeltaAggregations,
  beginVisualizationDownloadRanges, setVisualizationDownloadRanges,
  clearVisualizationDownloadRanges, buildVisualizationDownloadRange,
} from "@/elastic/queries";
import { getChildrenIds } from "@/vuex/modules/site";
import "chartjs-plugin-dragdata";
import {
  RadarChart,
  DoughnutChart,
  PieChart,
  PolarAreaChart,
  ScatterChart,
  BubbleChart
} from "vue-chart-3";
import { Chart as ChartJS, Interaction, Tooltip} from "chart.js";
import { createFormulaProcessor, parseSiteFormula, applySiteFormula } from '@/extlibs/formulaProcessor';
import { getFormulaTimestamp } from '@/extlibs/formulaDates';


// Interaction.modes.xExact = function (chart, e, options, useFinalPosition) {
//   // 1) Trouver le point le plus proche sur l’axe X (référence)
//   const nearest = ChartJS.Interaction.modes.nearest(chart, e, { ...options, axis: "x" }, useFinalPosition);
//   if (!nearest || nearest.length === 0) return [];
//
//   const refX = nearest[0].element.$context.parsed.x;
//
//   // 2) Retourner TOUS les points dont parsed.x == refX
//   const matches = [];
//   const metas = chart.getSortedVisibleDatasetMetas();
//
//   for (const meta of metas) {
//     for (let i = 0; i < meta.data.length; i++) {
//       const el = meta.data[i];
//       const ctx = el.$context;
//       if (!ctx || !ctx.parsed) continue;
//
//       if (ctx.parsed.x === refX) {
//         matches.push({ element: el, datasetIndex: meta.index, index: i });
//       }
//     }
//   }
//
//   return matches;
// };

const VerticalLinePlugin = {
  id: "verticalLine",
  beforeEvent(chart, args) {
    const isDisabled = chart?.options?.plugins?.verticalLine?.enabled === false;
    if (isDisabled) {
      chart.verticalLinePosition = null;
      return;
    }

    const { event } = args;
    const { chartArea } = chart;
    if (!chartArea) return;

    // Save the X coordinate of the cursor
    if (
      event.type === "mousemove" &&
      event.x >= chartArea.left &&
      event.x <= chartArea.right
    ) {
      chart.verticalLinePosition = event.x;
      //console.log(chart.verticalLinePosition != event.x);
    }
  },
  afterDatasetsDraw(chart) {
    const isDisabled = chart?.options?.plugins?.verticalLine?.enabled === false;
    if (isDisabled) return;

    const { ctx, chartArea } = chart;

    // Use the saved X position
    const xPosition = chart.verticalLinePosition;

    if (!xPosition) return;

    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([5, 5]); // Optional: Dashed line
    ctx.moveTo(xPosition, chartArea.top);
    ctx.lineTo(xPosition, chartArea.bottom);
    ctx.lineWidth = 1;
    ctx.strokeStyle = "rgba(0, 0, 0, 0.8)";
    ctx.stroke();
    ctx.restore();
  },
};

const ProgressiveLineRevealPlugin = {
  id: "progressiveLineReveal",
  beforeDatasetsDraw(chart, args, pluginOptions) {
    const opts = pluginOptions || {};
    const { ctx, chartArea } = chart;
    if (!chartArea) return;

    const anim = chart.$_revealAnim;
    if (!anim) return;

    const p = Math.max(0, Math.min(1, anim.progress || 0)); // 0..1

    const left = chartArea.left;
    const right = chartArea.right;
    const top = chartArea.top;
    const bottom = chartArea.bottom;

    const width = (right - left) * p;

    ctx.save();
    ctx.beginPath();
    ctx.rect(left, top, width, bottom - top);
    ctx.clip();
  },
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    ctx.restore();
  },
};

const DynamicGlobalMinMaxPlugin = {
  id: "dynamicGlobalMinMax",
  afterDatasetsDraw(chart) {
    // Ne fait rien si aucun axe n'utilise useGlobalMinMax
    const visualization = chart.$_visualizationConfig;
    if (!visualization || !visualization.axes || !visualization.axes.axes) return;

    let hasGlobalMinMax = false;
    for (let axe of visualization.axes.axes) {
      if (axe.useGlobalMinMax === true) {
        hasGlobalMinMax = true;
        break;
      }
    }

    if (!hasGlobalMinMax) return;

    // Recalcule min/max en fonction des datasets VISIBLES uniquement
    let globalMin = Number.MAX_VALUE;
    let globalMax = -Number.MAX_VALUE;

    for (let i = 0; i < chart.data.datasets.length; i++) {
      const meta = chart.getDatasetMeta(i);

      // Skip les datasets cachés
      if (meta.hidden) continue;

      const dataset = chart.data.datasets[i];
      const values = dataset.data.map(point => point.y).filter(v => v != null);

      if (values.length > 0) {
        globalMin = Math.min(globalMin, ...values);
        globalMax = Math.max(globalMax, ...values);
      }
    }

    if (globalMin === Number.MAX_VALUE || globalMax === -Number.MAX_VALUE) {
      return; // Aucune donnée visible
    }

    globalMin = Math.floor(globalMin) - 5;
    globalMax = Math.ceil(globalMax) + 5;

    // Applique aux axes concernés
    let needsUpdate = false;
    for (let k in visualization.axes.axes) {
      let axe = visualization.axes.axes[k];

      if (axe.useGlobalMinMax !== true) continue;

      const scale = chart.scales[k];
      if (!scale) continue;

      if (scale.options.min !== globalMin || scale.options.max !== globalMax) {
        scale.options.min = globalMin;
        scale.options.max = globalMax;
        needsUpdate = true;
      }
    }

    if (needsUpdate) {
      chart.update('none'); // Update sans animation
    }
  }
};

ChartJS.register(Tooltip, VerticalLinePlugin, ProgressiveLineRevealPlugin, DynamicGlobalMinMaxPlugin);

//ChartJS.register(Tooltip, VerticalLinePlugin, ProgressiveLineRevealPlugin);

export default {
  components: {
    Bar,
    RadarChart,
    DoughnutChart,
    PieChart,
    PolarAreaChart,
    ScatterChart,
    BubbleChart
  },
  props: {
    site: { type: Object, required: true },
    reload: { type: Boolean, required: false },
    loader: { type: Boolean, required: false, default: true },
    realtime: { type: Boolean, required: false, default: false },
    intervalType: { type: String, required: false, default: "minutes" },
    realtimeWindowSize: { type: Number, required: false, default: 5 },
    visualization: { type: Object, required: true },
    query: { type: Object, required: true },
    filters: { type: Object, required: false },
    yearCompareQuery: { type: Object, required: true },
    yearCompare: { type: Boolean, required: false },
    uniqueYearCompare: {type: Boolean, required: false},
    currentYearIndex: {type: Number, required: false},
    useAnimatedGraph: {type: Boolean, required: false},
    childIdsToName: Object,
  },
  data() {
    let children_site_ids = getChildrenIds(this.site);
    let intervalFormat = this.query.interval;
    if (intervalFormat == "data") {
      intervalFormat = "minute";
    }
    let xAxe = {
      x: {
        // type: "category",

        type: "time",
        time: {
          parser: "DD-MM-YYYY HH:mm",
          unit: intervalFormat,
          displayFormats: {
            // year: "YYYY",
            // month: "DD-MM-YYYY",
            // week: "DD-MM-YYYY",
            // day: "DD-MM-YYYY",
            hour: "MMM D, h A",
            minute: "h:mm A",
          },
        },

        ticks: {
          source: "auto",
          // callback: function (label) {
          //   return label;
          // },
        },
      },
      xLabel: {
        type: "linear",
        min: 0,
        max: 3,
        display: false,
      },
      yVegetal: {
        type: "linear",
        position: 'right',
        yMin: 0,
        yMax: 100,
        display: false,
      },
      calcFormAxe: {
        type: "linear",
        ticks: {
          color: "#FF0000",
          textStrokeColor: "#FF0000",
        },
        position: "left",
        display: false,
      },
    };
    return {
      updateId: 0,
      downloadRanges: [],
      custN: null,
      xAxe,
      myChart: undefined,
      eventIndex: 0,
      children_site_ids,
      elastic_winery_mesures_index: "winery_mesures_" + this.site.client_id,
      elastic_winery_events_index: "winery_events_" + this.site.client_id,
      eventLegendCount: {},
      chartReady: false,
      delayed: false,
      custNLog: null,
      min: Number.MAX_VALUE,
      max: -Number.MAX_VALUE,
      selectionMode: false,
      realtimeTimerId: null,
      chartData: {
        labels: [],
        datasets: [],
      },
      colors: [
        "#1f77b4", // muted blue
        "#ff7f0e", // safety orange
        "#2ca02c", // cooked asparagus green
        "#d62728", // brick red
        "#9467bd", // muted purple
        "#8c564b", // chestnut brown
        "#e377c2", // raspberry yogurt pink
        "#7f7f7f", // middle gray
        "#bcbd22", // curry yellow-green
        "#17becf", // blue-teal]
      ],
      colorIndex: -1,
      chartOptions: {
        /*animation: {
          onComplete: () => {
            this.delayed = true;
          },
          //from: NaN, // the point is initially skipped
          delay: (context) => {
            let delay = 0;
            if (context.type === "data" && context.mode === "default" && !this.delayed){
              delay = context.dataIndex * 100; //+ context.datasetIndex * 500;
            }
            return delay;
          }
        },*/
        /*animation: {
          duration: 5000,
          easing: "linear",
          onProgress: (anim) => {
            if(!this.delayed){
              // anim.currentStep / anim.numSteps n’existe pas pareil selon versions,
              // donc on calcule un ratio robuste.
              const p = anim?.currentStep && anim?.numSteps
                  ? anim.currentStep / anim.numSteps
                  : (typeof anim?.progress === "number" ? anim.progress : 0);

              anim.chart.$_revealAnim = { progress: p };
            }
          },
          onComplete: (anim) => {
            anim.chart.$_revealAnim = { progress: 1 };
            this.delayed = true;
          },
        },*/
        animations: {
          y: {
            duration: 0
          }
        },
        barValueSpacing: 20,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxe
        },
        interaction: {
          mode: 'nearest',
          intersect: false,
          axis: 'x',
        },
        elements: {
            point: {
              radius: 0,
              hoverRadius: 6 // taille au survol
            }
        },
        hover: {
          mode: 'index',  // ← Force à prendre TOUS les datasets au même index
          axis: 'x',
        },
        plugins: {
          progressiveLineReveal: {},
          verticalLine: {
            enabled: true,
          },
          annotation: {
            annotations: {

            },
          },
          tooltip: {
            position: 'bottom',
            mode: 'index',  // ← Force à prendre TOUS les datasets au même index
            axis: 'x',
            intersect: false,
            callbacks: {
              label: function(context) {
                const value = context.parsed.y;
                const unit = context.dataset.unit || "";
                const label = context.dataset.label || "";
                return label + ": " + value + " " + unit;
              }
            }
          },
          legend: {
            labels: {
              font: { size: 22 },
              // filter: function (legendItem, chartData) {
              //   if (typeof legendItem.text == "undefined") {
              //     return false;
              //   } else if (
              //     this.eventLegendCount[legendItem.text] !== undefined
              //   ) {
              //     return false;
              //   }
              //   this.eventLegendCount[legendItem.text] = 1;
              //   return true;
              // }.bind(this),
            },
          },
        },
      },
    };
  },
  watch: {
    reload: {
      handler() {
        this.updateGraphicData();
      },
    },
    query: {
      deep: true,
      handler() {
        this.updateGraphicData();
      },
    },
    filters: {
      deep: true,
      handler() {
        this.updateGraphicData();
      },
    },
    realtime: {
      handler() {
        this.syncRealtimeScheduler(true);
      },
    },
    intervalType: {
      handler() {
        if (this.realtime) {
          this.syncRealtimeScheduler(true);
        }
      },
    },
    realtimeWindowSize: {
      handler() {
        if (this.realtime) {
          this.syncRealtimeScheduler(true);
        }
      },
    },
  },
  mounted() {
    this.updateGraphicData();
    this.syncRealtimeScheduler(false);
    Tooltip.positioners.bottom = function(items, eventPosition) {
      const pos = Tooltip.positioners.average(items);

      // Happens when nothing is found
      if (pos === false) {
        return false;
      }

      const chart = this.chart;

      return {
        x: pos.x,
        y: eventPosition.y,
      };
    };
  },
  beforeDestroy() {
    clearVisualizationDownloadRanges(this.site.id, this);
    this.stopRealtimeScheduler();
  },
  beforeUnmount() {
    clearVisualizationDownloadRanges(this.site.id, this);
    this.stopRealtimeScheduler();
  },
  methods: {
    normalizeRealtimeIntervalType(value) {
      const normalized = String(value || "minutes").toLowerCase();
      if (normalized === "minutes" || normalized === "minute") return "minutes";
      if (normalized === "hours" || normalized === "hour") return "hours";
      if (normalized === "days" || normalized === "day") return "days";
      return "minutes";
    },
    getActiveRealtimeIntervalType() {
      return this.normalizeRealtimeIntervalType(this.intervalType);
    },
    normalizeRealtimeWindowSize(value, intervalType = this.getActiveRealtimeIntervalType()) {
      const numericValue = parseInt(value, 10);

      if (intervalType === "minutes") {
        return [5, 15, 30].includes(numericValue) ? numericValue : 5;
      }

      if (intervalType === "hours") {
        return [5, 10, 15, 20, 25, 30].includes(numericValue) ? numericValue : 5;
      }

      if (Number.isNaN(numericValue)) {
        return 5;
      }

      return Math.max(2, Math.min(30, numericValue));
    },
    getRealtimeWindowSize() {
      const intervalType = this.getActiveRealtimeIntervalType();
      return this.normalizeRealtimeWindowSize(this.realtimeWindowSize, intervalType);
    },
    isRealtimeActive() {
      return this.realtime === true;
    },
    getRealtimeQueryInterval() {
      const intervalType = this.getActiveRealtimeIntervalType();
      if (intervalType === "hours") return "hour";
      if (intervalType === "days") return "day";
      return "minute";
    },
    getRealtimeRefreshDelayMs() {
      const intervalType = this.getActiveRealtimeIntervalType();
      if (intervalType === "hours") return 60 * 60 * 1000;
      if (intervalType === "days") return 24 * 60 * 60 * 1000;
      return 60 * 1000;
    },
    getRealtimeWindowDates() {
      const intervalType = this.getActiveRealtimeIntervalType();
      const realtimeWindowSize = this.getRealtimeWindowSize();
      const delta = Math.max(0, realtimeWindowSize - 1);
      const endDate = new Date();
      const startDate = new Date(endDate);

      if (intervalType === "hours") {
        endDate.setMinutes(59, 59, 999);
        startDate.setTime(endDate.getTime());
        startDate.setHours(startDate.getHours() - delta, 0, 0, 0);
      } else if (intervalType === "days") {
        endDate.setHours(23, 59, 59, 999);
        startDate.setTime(endDate.getTime());
        startDate.setDate(startDate.getDate() - delta);
        startDate.setHours(0, 0, 0, 0);
      } else {
        endDate.setSeconds(59, 999);
        startDate.setTime(endDate.getTime());
        startDate.setMinutes(startDate.getMinutes() - delta);
        startDate.setSeconds(0, 0);
      }

      return {
        startDate,
        endDate,
      };
    },
    applyIntervalEndPrecision(date, interval) {
      const preciseDate = new Date(date);

      if (interval === "minute") {
        preciseDate.setSeconds(59, 999);
        return preciseDate;
      }

      if (interval === "hour") {
        preciseDate.setMinutes(59, 59, 999);
        return preciseDate;
      }

      if (interval === "data") {
        return preciseDate;
      }

      preciseDate.setHours(preciseDate.getHours(), 59, 59, 999);
      return preciseDate;
    },
    stopRealtimeScheduler() {
      if (this.realtimeTimerId) {
        clearInterval(this.realtimeTimerId);
        this.realtimeTimerId = null;
      }
    },
    syncRealtimeScheduler(forceRefresh = false) {
      this.stopRealtimeScheduler();

      if (this.isRealtimeActive()) {
        const refreshDelay = this.getRealtimeRefreshDelayMs();
        this.realtimeTimerId = setInterval(() => {
          this.updateGraphicData();
        }, refreshDelay);
      }

      if (forceRefresh) {
        this.updateGraphicData();
      }
    },
    calculateRevealDuration() {
      const MIN_DURATION = 4000;   // 1.5 seconds minimum
      const MAX_DURATION = 10000;  // 20 seconds maximum
      const MS_PER_POINT = 25;    // 100ms per data point

      const interval = this.query.interval;

      // Only apply custom duration for day, week, month intervals
      if (!['day', 'week', 'month'].includes(interval)) {
        return 5000;
      }

      let startDate = this.query.from ? new Date(this.query.from) : null;
      let endDate = this.query.to ? new Date(this.query.to) : null;

      if (!startDate || !endDate) {
        return 5000;
      }

      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      let numPoints;
      switch (interval) {
        case 'day':
          numPoints = diffDays;
          break;
        case 'week':
          numPoints = Math.ceil(diffDays / 7);
          break;
        case 'month':
          numPoints = Math.ceil(diffDays / 30);
          break;
        default:
          numPoints = diffDays;
      }

      const calculatedDuration = numPoints * MS_PER_POINT;

      return Math.max(MIN_DURATION, Math.min(MAX_DURATION, calculatedDuration));
    },
    reloadAnimation() {
      this.startRevealAnimation(5000);
    },
    easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 4);
    },
    getChartInstance() {
      //console.log(this.$refs.mainChartRef);
      return this.$refs.mainChartRef?.barChartRef.chartInstance;
    },
    startRevealAnimation(duration = 5000) {
      // Cancel any existing animation
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }

      const chart = this.getChartInstance();
      if (!chart) {
        // Retry if chart not ready
        //this.$nextTick(() => this.startRevealAnimation(duration));
        return;
      }

      const start = performance.now();
      this.progress = 0;
      chart.$_revealAnim = { progress: 0 };

      const tick = (now) => {
        const elapsed = now - start;
        const linearProgress = Math.min(elapsed / duration, 1);
        //const easedProgress = this.easeOutQuart(linearProgress);

        this.progress = linearProgress; //easedProgress;
        chart.$_revealAnim = { progress: linearProgress };
        chart.draw();

        if (linearProgress < 1) {
          this.animationId = requestAnimationFrame(tick);
        } else {
          this.animationId = null;
        }
      };

      this.animationId = requestAnimationFrame(tick);
    },
    formattedLog(dataLog) {
      try {
        // Return the beautifully formatted JSON string
        return JSON.stringify(dataLog, null, 2);
      } catch {
        // If parsing fails, just return the original data
        return dataLog;
      }
    },
    logVariableByName(variablePath) {
      const pathSegments = variablePath.split('.');
      let currentObject = this; // Assuming `this` is the Vue instance
      for (const segment of pathSegments) {
        if (segment in currentObject) {
          currentObject = currentObject[segment];
        } else {
          console.log(`Variable path ${variablePath} does not exist.`);
          return;
        }
      }
      console.log(currentObject);
      this.custNLog = this.formattedLog(currentObject);
    },
    isIntervalAllowEndDate() {
      return (
        this.query.interval != "data" &&
        this.query.interval != "hour" &&
        this.query.interval != "minute"
      );
    },
    removeSubstringBetweenSameChars(str, charToMatch) {
      // Check if the first character matches charToMatch
      if (str.charAt(0) === charToMatch) {
        // Find the index of the second occurrence of charToMatch
        let secondIndex = str.indexOf(charToMatch, 1);

        // If the second occurrence is found
        if (secondIndex !== -1) {
          // Extract the substring between the two occurrences
          let substring = str.substring(1, secondIndex);

          // Log the extracted substring

          // Remove the whole part from the original string and return it
          return [substring, str.slice(secondIndex + 1)];
        }
      }
      // If the first character does not match or second occurrence is not found,
      // return the original string
      return str;
    },
    setSelectionMode(){
      this.chartOptions.interaction.mode = (this.selectionMode === true ? 'index' : 'point');
    },
    getMesureText(item) {
      let name = "";
      if (item.site_id != this.site.id) {
        name += this.childIdsToName[item.site_id] + " : ";
      }
      name += item.name;
      return name;
    },
    currentVisualizationComponent() {
      return this.visualization && this.visualization.component ? this.visualization.component : "";
    },
    isRadarVisualization() {
      return this.currentVisualizationComponent().includes("RadarChart");
    },
    isHistogramChartVisualization() {
      return this.currentVisualizationComponent().includes("HistogramChart");
    },
    isDonutVisualization() {
      const component = this.currentVisualizationComponent();
      return component.includes("DonutChart") || component.includes("DoughnutChart");
    },
    isPieVisualization() {
      return this.currentVisualizationComponent().includes("PieChart");
    },
    isPolarAreaVisualization() {
      return this.currentVisualizationComponent().includes("PolarAreaChart");
    },
    isScatterVisualization() {
      return this.currentVisualizationComponent().includes("ScatterChart");
    },
    isBubbleVisualization() {
      return this.currentVisualizationComponent().includes("BubbleChart");
    },
    isAreaVisualization() {
      return this.currentVisualizationComponent().includes("AreaChart");
    },
    isCircularVisualization() {
      return this.isDonutVisualization() || this.isPieVisualization() || this.isPolarAreaVisualization();
    },
    shouldLoadEventAnnotations() {
      return !this.isHistogramChartVisualization() && !this.isCircularVisualization();
    },
    getNumericYFromPoint(point) {
      const y = Number(typeof point === "number" ? point : point && point.y);
      return Number.isFinite(y) ? y : null;
    },
    toRgba(color, alpha = 0.25) {
      if (!color || typeof color !== "string") {
        return `rgba(31, 119, 180, ${alpha})`;
      }
      if (color.startsWith("rgba(")) {
        const values = color.slice(5, -1).split(",").map(v => v.trim());
        if (values.length >= 3) {
          return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${alpha})`;
        }
      }
      if (color.startsWith("rgb(")) {
        const values = color.slice(4, -1).split(",").map(v => v.trim());
        if (values.length >= 3) {
          return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${alpha})`;
        }
      }
      if (color.startsWith("#")) {
        let hex = color.slice(1);
        if (hex.length === 3) {
          hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
        }
        if (hex.length >= 6) {
          const r = parseInt(hex.slice(0, 2), 16);
          const g = parseInt(hex.slice(2, 4), 16);
          const b = parseInt(hex.slice(4, 6), 16);
          if (Number.isFinite(r) && Number.isFinite(g) && Number.isFinite(b)) {
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
          }
        }
      }
      return `rgba(31, 119, 180, ${alpha})`;
    },
    getDatasetsWithNumericValues() {
      return this.chartData.datasets.filter((dataset) => {
        if (!dataset || !Array.isArray(dataset.data)) return false;
        return dataset.data.some((point) => this.getNumericYFromPoint(point) !== null);
      });
    },
    prepareCircularChart(kind = "doughnut") {
      const sourceDatasets = this.getDatasetsWithNumericValues();
      const labels = [];
      const values = [];
      const colors = [];
      const units = [];

      for (const dataset of sourceDatasets) {
        let total = 0;
        for (const point of dataset.data) {
          const y = this.getNumericYFromPoint(point);
          if (y !== null) total += y;
        }

        labels.push(dataset.label || `Dataset ${labels.length + 1}`);
        values.push(this.roundDecimal(total, 3));
        units.push(dataset.unit || "");

        const color = typeof dataset.backgroundColor === "string"
          ? dataset.backgroundColor
          : (typeof dataset.borderColor === "string" ? dataset.borderColor : this.getNextColor());
        colors.push(color);
      }

      this.chartData = {
        labels,
        datasets: [{
          data: values,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
          units,
        }],
      };

      this.chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          verticalLine: {
            enabled: false,
          },
          annotation: { annotations: {} },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || "";
                const value = context.parsed ?? context.raw ?? 0;
                const unit = (context.dataset.units && context.dataset.units[context.dataIndex]) || "";
                return `${label}: ${value}${unit ? " " + unit : ""}`;
              }
            }
          },
          legend: {
            labels: {
              font: { size: 18 },
            },
          },
        },
      };

      if (kind === "doughnut") {
        this.chartOptions.cutout = "58%";
      }
    },
    prepareAreaChart() {
      const filteredDatasets = this.getDatasetsWithNumericValues().map((dataset) => {
        const stroke = typeof dataset.borderColor === "string"
          ? dataset.borderColor
          : (typeof dataset.backgroundColor === "string" ? dataset.backgroundColor : this.getNextColor());

        return {
          ...dataset,
          type: "line",
          showLine: true,
          fill: true,
          tension: 0.35,
          pointRadius: 0,
          pointHoverRadius: 5,
          borderWidth: 2,
          backgroundColor: this.toRgba(stroke, 0.2),
        };
      });

      this.chartData.datasets = filteredDatasets;
      this.chartOptions.interaction = {
        mode: "index",
        intersect: false,
        axis: "x",
      };
    },
    prepareScatterChart() {
      const filteredDatasets = this.getDatasetsWithNumericValues().map((dataset) => {
        const points = [];
        for (let i = 0; i < dataset.data.length; i++) {
          const point = dataset.data[i];
          const y = this.getNumericYFromPoint(point);
          if (y === null) continue;

          const hasX = point && typeof point === "object" && Object.prototype.hasOwnProperty.call(point, "x");
          points.push({
            x: hasX ? point.x : i,
            y,
          });
        }

        return {
          ...dataset,
          type: "scatter",
          showLine: false,
          data: points,
          pointRadius: 4,
          pointHoverRadius: 6,
        };
      });

      this.chartData.datasets = filteredDatasets;
      this.chartOptions.interaction = {
        mode: "nearest",
        intersect: false,
        axis: "xy",
      };
    },
    prepareBubbleChart() {
      const filteredDatasets = this.getDatasetsWithNumericValues().map((dataset) => {
        const values = dataset.data.map((point) => this.getNumericYFromPoint(point)).filter((y) => y !== null);
        const maxAbs = values.length > 0 ? Math.max(...values.map((value) => Math.abs(value)), 1) : 1;

        const points = [];
        for (let i = 0; i < dataset.data.length; i++) {
          const point = dataset.data[i];
          const y = this.getNumericYFromPoint(point);
          if (y === null) continue;

          const hasX = point && typeof point === "object" && Object.prototype.hasOwnProperty.call(point, "x");
          const rawRadius = 4 + (Math.abs(y) / maxAbs) * 12;
          points.push({
            x: hasX ? point.x : i,
            y,
            r: this.roundDecimal(Math.max(4, Math.min(16, rawRadius)), 2),
          });
        }

        return {
          ...dataset,
          type: "bubble",
          showLine: false,
          data: points,
        };
      });

      this.chartData.datasets = filteredDatasets;
      this.chartOptions.interaction = {
        mode: "nearest",
        intersect: false,
        axis: "xy",
      };
    },
    prepareHistogramChart() {
      const stackedMax = this.getHistogramStackedMax();
      this.chartOptions.plugins.annotation.annotations = {};

      this.chartOptions.interaction = {
        mode: "index",
        intersect: false,
        axis: "x",
      };
      this.chartOptions.plugins.tooltip = {
        ...this.chartOptions.plugins.tooltip,
        mode: "index",
        axis: "x",
        intersect: false,
        callbacks: {
          label: function(context) {
            const label = context.dataset.label || "";
            const value = context.parsed.y ?? 0;
            const unit = context.dataset.unit || "";
            return `${label}: ${value}${unit ? " " + unit : ""}`;
          },
        },
      };
      this.chartOptions.scales.x = {
        ...this.chartOptions.scales.x,
        stacked: true,
      };
      this.chartOptions.scales.y = {
        type: "linear",
        beginAtZero: true,
        stacked: true,
        max: stackedMax > 0 ? stackedMax * 1.05 : undefined,
      };
    },
    getHistogramStackedMax() {
      const sumsByKey = {};

      for (const dataset of this.chartData.datasets) {
        if (!dataset || dataset.type !== "bar" || !Array.isArray(dataset.data)) continue;

        for (let i = 0; i < dataset.data.length; i++) {
          const point = dataset.data[i];
          const y = Number(typeof point === "number" ? point : point && point.y);
          if (!Number.isFinite(y)) continue;

          const xKey = `idx_${i}`;

          sumsByKey[xKey] = (sumsByKey[xKey] || 0) + y;
        }
      }

      const totals = Object.values(sumsByKey);
      if (totals.length === 0) return 0;
      return Math.max(...totals);
    },
    // Add this to your methods:
    generateBackgroundZones(zones) {
      if (zones == null || zones === "" || zones === "null") {
        return {};
      }

      // Parse if it's a string
      if (typeof zones === 'string') {
        try {
          zones = JSON.parse(zones);
        } catch {
          return {};
        }
      }

      // Convert to array if it's an object
      if (zones && typeof zones === 'object' && !Array.isArray(zones)) {
        zones = Object.values(zones);
      }

      // Final check
      if (!zones || !Array.isArray(zones) || zones.length === 0) {
        return {};
      }

      const annotations = {};
      const opacity = 0.25;

      const hexToRgba = (hex, alpha) => {
        if (typeof hex === 'object' && hex.hex) {
          hex = hex.hex;
        }
        if (!hex) return `rgba(0, 0, 0, ${alpha})`;
        hex = hex.replace('#', '');
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      };

      // Calculate positions based on ratios
      let currentY = 100;

      zones.forEach((zone, index) => {
        // Use ratio if available, otherwise equal distribution
        const zoneRatio = zone.ratio !== undefined ? zone.ratio : (100 / zones.length);

        const yMax = currentY;
        const yMin = currentY - zoneRatio;
        const yCenter = (yMax + yMin) / 2;

        currentY = yMin;

        // Background box
        annotations[`box_${index}`] = {
          drawTime: "beforeDraw",
          display: true,
          type: "box",
          yMin: yMin,
          yMax: yMax,
          backgroundColor: hexToRgba(zone.color, opacity),
          yScaleID: "yVegetal",
        };

        // Label
        annotations[`label_${index}`] = {
          drawTime: "beforeDraw",
          display: true,
          type: 'label',
          xValue: 0.1,
          xScaleID: "xLabel",
          yValue: yCenter,
          yScaleID: "yVegetal",
          padding: 20,
          backgroundColor: 'rgba(245, 245, 245, 0)',
          color: 'rgba(125, 125, 125)',
          textStrokeColor: 'rgba(125, 125, 125)',
          textStrokeWidth: 1.5,
          textAlign: 'center',
          content: [zone.text],
          font: {
            size: 42
          }
        };
      });

      return annotations;
    },
    createMinMaxDataset(axeKey, mesure, data, times, interval, axeColor, order, formulaTimestamps = null, keepFormulaTimestamps = true) {
      /**
       * Creates min and max datasets with gradient fill between them
       * Uses actual aggregated min/max values from elastic data
       */

      const minData = [];
      const maxData = [];
      const csvCol = mesure.csv_column;
      const minProcessor = createFormulaProcessor(mesure);
      const maxProcessor = createFormulaProcessor(mesure);
      const hasTemporalConditions = (minProcessor.config?.rules || []).some(rule =>
          ['dateCompare', 'dateTimeCompare', 'timeCompare'].includes(rule.type));

      // Extract actual min/max values from aggregated data
      if (interval !== "data") {
        for (let i = 0; i < Math.min(times.length, data.length); i++) {
          const row = data[i];

          let minVal = null;
          let maxVal = null;

          // Get min value from _min aggregation
          if (row[csvCol + '_min'] && row[csvCol + '_min'].value !== undefined && row[csvCol + '_min'].value !== null) {
            minVal = row[csvCol + '_min'].value;
          }

          // Get max value from _max aggregation
          if (row[csvCol + '_max'] && row[csvCol + '_max'].value !== undefined && row[csvCol + '_max'].value !== null) {
            maxVal = row[csvCol + '_max'].value;
          }

          if (minVal !== null) {
            const result = hasTemporalConditions
                ? minProcessor.process(minVal, formulaTimestamps?.[i] || getFormulaTimestamp(row, times[i], this.site.data_timeoffset), minData)
                : { show: true, value: minVal };
            if (result.show) {
              minData.push({ x: times[i], y: this.roundDecimal(result.value, 3),
                ...(formulaTimestamps && keepFormulaTimestamps ? { formulaTimestamp: formulaTimestamps[i] } : {}) });
            }
          }
          if (maxVal !== null) {
            const result = hasTemporalConditions
                ? maxProcessor.process(maxVal, formulaTimestamps?.[i] || getFormulaTimestamp(row, times[i], this.site.data_timeoffset), maxData)
                : { show: true, value: maxVal };
            if (result.show) {
              maxData.push({ x: times[i], y: this.roundDecimal(result.value, 3),
                ...(formulaTimestamps && keepFormulaTimestamps ? { formulaTimestamp: formulaTimestamps[i] } : {}) });
            }
          }
        }
      } else {
        // Raw data - no aggregation
        return [];
      }

      // If we couldn't extract min/max data, return empty
      if (minData.length === 0 || maxData.length === 0) {
        console.warn(`[createMinMaxDataset] No min/max data found for ${csvCol}. Check if aggregationsType is "Min/Max"`);
        return [];
      }

      // Get color in hex format
      const colorHex = typeof axeColor === 'object' ? axeColor.hex : axeColor;

      const hexToRgba = (hex, alpha) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      };

      const lightenColor = (hex, percent) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);

        // Lighten by mixing with white
        const newR = Math.min(255, Math.round(r + (255 - r) * (percent / 100)));
        const newG = Math.min(255, Math.round(g + (255 - g) * (percent / 100)));
        const newB = Math.min(255, Math.round(b + (255 - b) * (percent / 100)));

        return `rgb(${newR}, ${newG}, ${newB})`;
      };

      const lightenColorRgba = (hex, percent, alpha) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);

        // Lighten by mixing with white
        const newR = Math.min(255, Math.round(r + (255 - r) * (percent / 100)));
        const newG = Math.min(255, Math.round(g + (255 - g) * (percent / 100)));
        const newB = Math.min(255, Math.round(b + (255 - b) * (percent / 100)));

        return `rgba(${newR}, ${newG}, ${newB}, ${alpha})`;
      };

      const fillColor = lightenColorRgba(colorHex, 50, 0.3);
      const borderColor = hexToRgba(colorHex, 1);

      // Min dataset (bottom line)
      const minDataset = {
        yAxisID: axeKey,
        label: mesure.name + ' (Min)',
        borderColor: borderColor,
        backgroundColor: 'transparent',
        //borderWidth: 1,
        //borderDash: [5, 5],
        data: minData,
        type: 'line',
        showLine: true,
        fill: false,
        //pointRadius: 0,
        //pointHoverRadius: 3,
        order: order - 0.2,
        tension: 0.4,
        unit: mesure.unit_of_measure,
      };

      // Max dataset (top line with fill down to min)
      const maxDataset = {
        yAxisID: axeKey,
        label: mesure.name + ' (Max)',
        borderColor: borderColor,
        backgroundColor: fillColor,
        //borderWidth: 1,
        //borderDash: [5, 5],
        data: maxData,
        type: 'line',
        showLine: true,
        fill: '-1', // Fill to previous dataset (min)
        //pointRadius: 0,
        //pointHoverRadius: 3,
        order: order - 0.1,
        tension: 0.4,
        unit: mesure.unit_of_measure,
      };

      return [minDataset, maxDataset];
    },
    async updateGraphicData() {
      this.updateId = this.updateId + 1;
      let updateId = this.updateId;
      this.downloadRanges = [];
      beginVisualizationDownloadRanges(this.site.id, this, updateId);
      this.eventLegendCount = {};
      this.curveId = 0;
      this.chartReady = false;
      this.chartData = {
        datasets: [],
        labels: [],
      };

      if (!this.chartOptions.plugins) {
        this.chartOptions.plugins = {};
      }
      if (!this.chartOptions.plugins.annotation) {
        this.chartOptions.plugins.annotation = { annotations: {} };
      }
      if (!this.chartOptions.plugins.annotation.annotations) {
        this.chartOptions.plugins.annotation.annotations = {};
      }
      if (!this.chartOptions.plugins.tooltip) {
        this.chartOptions.plugins.tooltip = {
          mode: "index",
          axis: "x",
          intersect: false,
          callbacks: {},
        };
      }

      // Replace the Vegetal Signal section with:
      if (this.visualization.annotations && this.visualization.annotations.length > 0) {
        this.chartOptions.plugins.annotation.annotations = this.generateBackgroundZones(this.visualization.annotations);
      } else if (this.site.ftp_path != null && this.site.ftp_path.includes("/Vegetal Signal/")) {
        // Fallback to default Vegetal Signal zones
        const vegetalZones = [
          { text: 'Confort', color: '#65E9AB' },
          { text: 'Contrainte', color: '#FF9A00' },
          { text: 'Stress', color: '#E51616' }
        ];
        this.chartOptions.plugins.annotation.annotations = this.generateBackgroundZones(vegetalZones);
      }
      this.chartOptions.scales = JSON.parse(JSON.stringify(this.xAxe));

      let startDate = new Date();
      startDate.setFullYear(1900);
      let endDate = new Date();

      let interval = this.query.interval;
      const realtimeMode = this.isRealtimeActive();
      const useYearCompare = this.yearCompare && !realtimeMode;

      if (realtimeMode) {
        interval = this.getRealtimeQueryInterval();
      }

      if (useYearCompare) {

        if ((this.yearCompareQuery.from || this.yearCompareQuery.to) && !this.uniqueYearCompare) {
          if(this.yearCompareQuery.years != null){
            if (this.yearCompareQuery.from) {
              for(let year of this.yearCompareQuery.years){
                startDate[year] = convertDatePickerToDate(this.yearCompareQuery.from[year]);
                startDate[year].setHours(0);
                startDate[year].setMinutes(0);
              }
            }
            if (this.yearCompareQuery.to) {
              for(let year of this.yearCompareQuery.years){
                endDate[year] = convertDatePickerToDate(this.yearCompareQuery.to[year]);
                endDate[year].setHours(0);
                endDate[year].setMinutes(0);
              }
            }
          }
          interval = this.yearCompareQuery.interval;
        }

        let i = 0;
        if (this.visualization.axes && this.visualization.axes.axes.length > 0 && this.yearCompareQuery.years !== null) {

          if(this.uniqueYearCompare && this.uniqueYearCompare == true){
            if(this.yearCompareQuery.interval === "minute" || this.yearCompareQuery.interval === "hour"){
              for(let cIndex = 1; cIndex < this.yearCompareQuery.uniqueYear.count + 1; cIndex++){
                let year = this.yearCompareQuery.uniqueYear.year;
                if (this.yearCompareQuery.fromUnique) {
                    startDate[year + "_" + cIndex] = new Date(this.yearCompareQuery.fromUnique[year + "_" + cIndex]);
                    startDate[year + "_" + cIndex].setHours(0);
                    startDate[year + "_" + cIndex].setMinutes(0);
                }
                if (this.yearCompareQuery.toUnique) {
                    endDate[year + "_" + cIndex] = new Date(this.yearCompareQuery.toUnique[year + "_" + cIndex]);
                    endDate[year + "_" + cIndex].setHours(0);
                    endDate[year + "_" + cIndex].setMinutes(0);
                }

                interval = this.yearCompareQuery.interval;

                startDate[year + "_" + cIndex].setFullYear(year);
                endDate[year + "_" + cIndex].setFullYear(year);
                await this.updateGraphicMesuresData(
                    updateId,
                    startDate[year + "_" + cIndex],
                    endDate[year + "_" + cIndex],
                    interval,
                    false,
                    i
                ).catch((err) => {
                    this.showErrMesuresDataLoading(err);
                });
                i++;
                if (updateId != this.updateId) {
                    return;
                }
              }
            } else {
              let year = this.yearCompareQuery.uniqueYear.year;
              const periodIndex = Math.max(0, (parseInt(this.currentYearIndex, 10) || 1) - 1);
              if (this.yearCompareQuery.fromUnique) {
                startDate[year + "_" + this.currentYearIndex] = convertDatePickerToDate(this.yearCompareQuery.fromUnique[year + "_" + this.currentYearIndex]);
                startDate[year + "_" + this.currentYearIndex].setHours(0);
                startDate[year + "_" + this.currentYearIndex].setMinutes(0);
              }
              if (this.yearCompareQuery.toUnique) {
                endDate[year + "_" + this.currentYearIndex] = convertDatePickerToDate(this.yearCompareQuery.toUnique[year + "_" + this.currentYearIndex]);
                endDate[year + "_" + this.currentYearIndex].setHours(0);
                endDate[year + "_" + this.currentYearIndex].setMinutes(0);
              }

              interval = this.yearCompareQuery.interval;

              startDate[year + "_" + this.currentYearIndex].setFullYear(year);
              endDate[year + "_" + this.currentYearIndex].setFullYear(year);
              await this.updateGraphicMesuresData(
                  updateId,
                  startDate[year + "_" + this.currentYearIndex],
                  endDate[year + "_" + this.currentYearIndex],
                  interval,
                  false,
                  periodIndex
              ).catch((err) => {
                  this.showErrMesuresDataLoading(err);
              });
              i++;
              if (updateId != this.updateId) {
                  return;
              }
            }
          } else {
            for(let year of this.yearCompareQuery.years){
              startDate[year].setFullYear(year);
              endDate[year].setFullYear(year);
              await this.updateGraphicMesuresData(
                updateId,
                startDate[year],
                endDate[year],
                interval,
                useYearCompare,
                i
              ).catch((err) => {
                this.showErrMesuresDataLoading(err);
              });
              i++;
              if (updateId != this.updateId) {
                return;
              }
            }
          }


        }
        if (
          this.visualization.events &&
          this.visualization.events.length > 0 &&
          this.shouldLoadEventAnnotations() &&
          !(
            useYearCompare &&
            (interval == "year" || interval == "month" || interval == "week")
          )
        ) {
          i = 0;
          for (let year of this.yearCompareQuery.years) {
            startDate.setFullYear(year);
            endDate.setFullYear(year);
            await this.initGraphicEventData(
              updateId,
              startDate,
              endDate,
              interval,
              true,
              i
            ).catch((err) => {
              this.showErrEventDataLoading(err);
            });

            i++;
          }
        }
      } else {
        if (realtimeMode) {
          const realtimeWindow = this.getRealtimeWindowDates();
          startDate = realtimeWindow.startDate;
          endDate = realtimeWindow.endDate;
        } else if (this.query.from || this.query.to) {
          if (this.query.from) {
            startDate = new Date(this.query.from);
            startDate.setHours(0);
            startDate.setMinutes(0);
          }
          if (this.query.to) {
            endDate = new Date(this.query.to);
            endDate.setHours(23);
            endDate.setMinutes(59);
          }
          if (!this.isIntervalAllowEndDate()) {
            startDate = new Date(this.query.from);
            startDate.setHours(this.query.timerange[0]);
            endDate = new Date(this.query.from);
            endDate.setHours(this.query.timerange[1]);
          }
        }
        this.rememberDownloadRange(updateId, startDate, endDate, interval);
        // console.log("visualization : " + JSON.stringify(this.visualization));

        if (this.visualization.axes && this.visualization.axes.axes.length > 0) {
          await this.updateGraphicMesuresData(
            updateId,
            startDate,
            endDate,
            interval,
            useYearCompare,
            0
          ).catch((err) => {
            this.showErrMesuresDataLoading(err);
          });
        }
        if (updateId != this.updateId) {
          return;
        }
        if (
          this.visualization.events &&
          this.visualization.events.length > 0 &&
          this.shouldLoadEventAnnotations() &&
          !(useYearCompare && interval == "year")
        ) {
          this.eventIndex = 0;
          // console.log("initGraphicEventData");
          await this.initGraphicEventData(
            updateId,
            startDate,
            endDate,
            interval,
            false,
            0
          ).catch((err) => {
            this.showErrEventDataLoading(err);
          });
          // console.log("initGraphicEventDataFormSaisiesPromise");
          await this.initGraphicEventDataFormSaisiesPromise(
            updateId,
            startDate,
            endDate,
            interval,
            false
          ).catch((err) => {
            this.showErrEventDataLoading(err);
          });
          if (updateId != this.updateId) {
            return;
          }
          if (!useYearCompare) {
            if(this.isRadarVisualization() || this.isHistogramChartVisualization() || this.isCircularVisualization()){
              let voidvar = 0;
            } else {
              for (let event of this.visualization.events) {
                let borderColor = getColor(event);
                let legend = {
                  label: event,
                  borderColor,
                  backgroundColor: borderColor,
                  data: [{}, {}],
                  order: -999999999,
                };
                this.chartData.datasets.push(legend);
              }
            }
          }
        }
      }
      // console.log(this.query);
      if (updateId != this.updateId) {
        return;
      }

      if(this.isRadarVisualization()){
        this.chartData.labels = this.visualization.events;
        this.chartOptions = {
          maintainAspectRatio: false,
          plugins: {
            verticalLine: {
              enabled: false,
            },
            dragData: {
              round: 0,
              magnet: {
                //to: Math.round()
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.dataset.label || "";
                  const value = context.parsed.r ?? context.raw ?? 0;
                  const unit = context.dataset.unit || "";
                  return `${label}: ${value}${unit ? " " + unit : ""}`;
                }
              }
            }
          },
          scales: {
            r: {
              stepSize: 1,
              min: 0,
              max: 10,
              angleLines: {
                color: 'red',
                lineWidth: 4,
              }
            }
          },
          elements: {
            point: {
              radius: 6,
            }
          },
          legend: {
            labels: {
              font: {
                size: 36
              }
            }
          }
        };

        for(let key of Object.keys(this.chartData.datasets)) {
          delete this.chartData.datasets[key].order;
          delete this.chartData.datasets[key].yAxisID;
          for(let nkey of Object.keys(this.chartData.datasets[key].data)){
            this.chartData.datasets[key].data[nkey] = this.chartData.datasets[key].data[nkey].y;
            //delete this.chartData.datasets[key].data[nkey].y;
            //delete this.chartData.datasets[key].data[nkey].x;
          }
        }
      } else {
        if (!this.isCircularVisualization()) {
          if(useYearCompare){

            if(!this.uniqueYearCompare && !this.uniqueYearCompare == true){
              let minDate = convertDatePickerToDate(this.yearCompareQuery.minDate.mn);
              minDate.setHours(0);
              minDate.setMinutes(0);
              minDate.setFullYear(this.yearCompareQuery.minDate.year);

              let maxDate = convertDatePickerToDate(this.yearCompareQuery.maxDate.mx);
              maxDate.setHours(0);
              maxDate.setMinutes(0);
              maxDate.setFullYear(this.yearCompareQuery.maxDate.year);

              this.setGraphicLabels(minDate, maxDate, interval, useYearCompare);
            } else {
              let year = this.yearCompareQuery.uniqueYear.year;
              this.setGraphicLabels(startDate[year + "_" + this.currentYearIndex], endDate[year + "_" + this.currentYearIndex], interval, false);
            }

          } else {
            this.setGraphicLabels(new Date(startDate), new Date(endDate), interval, useYearCompare);
          }
        }

        if (this.isHistogramChartVisualization()) {
          this.prepareHistogramChart();
        } else if (this.isDonutVisualization()) {
          this.prepareCircularChart("doughnut");
        } else if (this.isPieVisualization()) {
          this.prepareCircularChart("pie");
        } else if (this.isPolarAreaVisualization()) {
          this.prepareCircularChart("polarArea");
        } else if (this.isScatterVisualization()) {
          this.prepareScatterChart();
        } else if (this.isBubbleVisualization()) {
          this.prepareBubbleChart();
        } else if (this.isAreaVisualization()) {
          this.prepareAreaChart();
        }
      }

      setVisualizationDownloadRanges(this.site.id, this, updateId, this.downloadRanges);
      this.chartReady = true;
      // Wait for chart to update, then animate
      this.$nextTick(() => {
        const duration = this.calculateRevealDuration();
        this.startRevealAnimation(duration);
      });
    },

    async getMesureData(startDate, endDate, interval, site_id, mesure) {
      let mesures = [];
      mesures.push(mesure);
      return await new Promise((resolve, reject) => {

        let newStartDate = new Date(startDate);
        let currentSHours = newStartDate.getHours();
        let adjustedSHours = currentSHours + this.site['data_timeoffset'];
        if (adjustedSHours < 0) {
          newStartDate.setDate(newStartDate.getDate() - 1);  // Move to the previous day
          adjustedSHours = 24 + adjustedSHours;  // Adjust hours to the 0-23 range
        }
        newStartDate.setHours(adjustedSHours);

        let newEndDate = new Date(endDate);
        let currentEHours = newEndDate.getHours();
        let adjustedEHours = currentEHours + this.site['data_timeoffset'];
        if (adjustedEHours < 0) {
          newEndDate.setDate(newEndDate.getDate() - 1);  // Move to the previous day
          adjustedEHours = 24 + adjustedEHours;  // Adjust hours to the 0-23 range
        }
        newEndDate.setHours(adjustedEHours);
        newEndDate = this.applyIntervalEndPrecision(newEndDate, interval);

        let elasticQuery = buildTimeRangeQuery(
          newStartDate,
          newEndDate,
          interval,
          site_id,
          mesures
        );

        let size = 0;
        if (interval == "data") {
          size = 1000000;
        }

        this.$store
          .dispatch("elasticSearchRequest", {
            index: this.elastic_winery_mesures_index,
            body: elasticQuery,
            size: size,
            site: site_id,
          })
          .then((rawResult) => {
            const result = applyDeltaAggregations(rawResult);
            let rows;
            if (
              interval != "data" &&
              (!result.data.aggregations.time_buckets.buckets ||
                result.data.aggregations.time_buckets.buckets.length <= 0)
            ) {
              resolve(rows);
              return;
            }

            if (interval && interval == "data") {
              if (result.data["hits"]["hits"].length > 0) {
                rows = result.data["hits"]["hits"].map((row) => {
                  const src = row._source;

                  const d = new Date(src["@timestamp"]);

                  const pad = (n) => n.toString().padStart(2, "0");

                  const key_as_string =
                      `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ` +
                      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

                  return {
                    ...src,
                    key_as_string
                  };
                });
              }
            } else {
              rows = result.data.aggregations.time_buckets.buckets;
              rows = rows.filter((row) => row["doc_count"] > 0);
            }
            resolve(rows);
          })
          .catch(reject);
      });
    },

    async getMesuresData(
      startDate,
      endDate,
      interval,
      mesures,
      filters,
      site_id,
      children_site_ids
    ) {
      return await new Promise((resolve, reject) => {

        let extendedStartDate = new Date(startDate);

        //console.log('🔍 BEFORE EXTEND:', extendedStartDate.toISOString(), 'interval:', interval);

        /*const timeOffset = Number(this.site['data_timeoffset'] || 0);

        if (timeOffset !== 0) {
          extendedStartDate.setTime(
            extendedStartDate.getTime() - timeOffset * 60 * 60 * 1000
          );
        }

        //console.log('🔍 AFTER EXTEND:', extendedStartDate.toISOString());

        let newStartDate = new Date(extendedStartDate);
        let currentSHours = newStartDate.getHours();
        let adjustedSHours = currentSHours + this.site['data_timeoffset'];
        if (adjustedSHours < 0) {
            newStartDate.setDate(newStartDate.getDate() - 1);  // Move to the previous day
            adjustedSHours = 24 + adjustedSHours;  // Adjust hours to the 0-23 range
        }
        newStartDate.setHours(adjustedSHours);

        let newEndDate = new Date(endDate);
        let currentEHours = newEndDate.getHours();
        let adjustedEHours = currentEHours + this.site['data_timeoffset'];
        if (adjustedEHours < 0) {
            newEndDate.setDate(newEndDate.getDate() - 1);  // Move to the previous day
            adjustedEHours = 24 + adjustedEHours;  // Adjust hours to the 0-23 range
        }
        newEndDate.setHours(adjustedEHours);
        newEndDate = this.applyIntervalEndPrecision(newEndDate, interval);*/

        const timeOffset = Number(this.site['data_timeoffset'] || 0);
        const offsetMs = timeOffset * 60 * 60 * 1000;

        // startDate et endDate correspondent à la période à afficher.
        const newStartDate = new Date(
          new Date(startDate).getTime() - offsetMs
        );

        // Ajuster la précision AVANT de décaler vers les dates des données.
        const preciseEndDate = this.applyIntervalEndPrecision(
          new Date(endDate),
          interval
        );

        const newEndDate = new Date(
          preciseEndDate.getTime() - offsetMs
        );

        //console.log('🔍 QUERY START:', newStartDate.toISOString());
        //console.log('🔍 QUERY END:', newEndDate.toISOString());

        let elasticQuery = buildTimeRangeQuery(
          newStartDate,
          newEndDate,
          interval,
          site_id,
          mesures,
          filters,
          children_site_ids
        );

        let size = 0;
        if (interval == "data") {
          size = 10000;
        }
        this.$store
          .dispatch("elasticSearchRequest", {
            index: this.elastic_winery_mesures_index,
            body: elasticQuery,
            size: size,
            site: this.visualization.site_id,
          })
          .then((rawResult) => {
            const result = applyDeltaAggregations(rawResult);
            let rows = [];

            if (
                interval != "data" &&
                (!result.data.aggregations.time_buckets.buckets ||
                    result.data.aggregations.time_buckets.buckets.length <= 0)
            ) {
              resolve({ rows: [], previousData: null });
              return;
            }

            if (interval && interval == "data") {
              if (result.data["hits"]["hits"].length > 0) {
                resolve({ rows: result.data["hits"]["hits"].map((row) => row._source), previousData: null });
              }
            } else {
              rows = result.data.aggregations.time_buckets.buckets;
            }

            if (!rows || rows.length == 0) {
              resolve({ rows: [], previousData: null });
              return;
            }

            // ✅ TROUVE LE BUCKET PRÉCÉDENT LE PLUS PROCHE AVANT startDate
            // let previousIntervalData = null;
            // let indexToSplit = -1;
            //
            // // Convertit startDate en timestamp (millisecondes)
            // const startDateTimestamp = startDate.getTime();
            //
            // for (let i = 0; i < rows.length; i++) {
            //   const row = rows[i];
            //   let rowTimestamp;
            //
            //   if (interval === "data") {
            //     // Parse la date ISO
            //     rowTimestamp = new Date(row["@timestamp"]).getTime();
            //   } else {
            //     // Utilise directement le timestamp en millisecondes
            //     rowTimestamp = row.key; // ← DIRECT, PAS DE PARSING !
            //   }
            //
            //   // Compare directement les timestamps
            //   if (rowTimestamp < startDateTimestamp) {
            //     // Ce bucket est avant startDate
            //     previousIntervalData = row;
            //     indexToSplit = i;
            //   } else {
            //     // On a atteint ou dépassé startDate, on arrête
            //     break;
            //   }
            // }

            // ✅ TROUVE LE BUCKET PRÉCÉDENT LE PLUS PROCHE AVANT startDate AVEC AU MOINS UNE VALEUR NON-NULL
            let previousIntervalData = null;
            let indexToSplit = -1;

            const startDateTimestamp = startDate.getTime();

            for (let i = 0; i < rows.length; i++) {
              const row = rows[i];
              let rowTimestamp;

              if (interval === "data") {
                rowTimestamp = new Date(row["@timestamp"]).getTime();
              } else {
                rowTimestamp = row.key;
              }

              if (rowTimestamp < startDateTimestamp) {
                // 🔥 FIX: Vérifie que ce bucket a AU MOINS UNE valeur non-null
                let hasValidData = false;
                for (let key in row) {
                  // Skip les métadonnées
                  if (key === 'key' || key === 'key_as_string' || key === 'doc_count') {
                    continue;
                  }

                  const val = row[key];
                  // Vérifie si c'est un objet avec .value non-null
                  if (val && typeof val === 'object' && val.value !== undefined && val.value !== null) {
                    hasValidData = true;
                    break;
                  }
                }

                // ✅ Garde ce bucket seulement s'il a des données valides
                if (hasValidData) {
                  previousIntervalData = row;
                  indexToSplit = i;
                }
              } else {
                break;
              }
            }

            // ✅ SI on a trouvé un bucket précédent, on le retire du tableau
            if (indexToSplit >= 0) {
              rows = rows.slice(indexToSplit + 1);
              console.log('✅ PREVIOUS DATA trouvée:', new Date(previousIntervalData.key).toISOString());
            } else {
              console.log('⚠️ Aucun bucket avant startDate');
            }

            // Filtre les rows avec doc_count > 0
            rows = rows.filter((row) => row["doc_count"] > 0);

            resolve({
              rows: rows,
              previousData: previousIntervalData
            });
          })
          .catch(reject);
      });
    },

    rememberDownloadRange(updateId, startDate, endDate, interval) {
      if (updateId !== this.updateId) return;
      this.downloadRanges.push(buildVisualizationDownloadRange(
        startDate,
        endDate,
        this.site.data_timeoffset,
        date => this.applyIntervalEndPrecision(date, interval)
      ));
    },

    async updateGraphicMesuresData(
      updateId,
      startDate,
      endDate,
      interval,
      yearCompare,
      yearId
    ) {
      this.rememberDownloadRange(updateId, startDate, endDate, interval);
      const histogramMode = this.isHistogramChartVisualization();
      const siteFormulaConfig = parseSiteFormula(this.site.calcForm);
      const firstDatasetIndex = this.chartData.datasets.length;
      let mesuresToLoad = [];
      // console.log(this.visualization.axes.axes);
      for (let axe of this.visualization.axes.axes) {
        if (histogramMode && !this.isHistogramAxis(axe)) {
          continue;
        }
        for (let mesure of axe.mesures) {
          let m = { ...mesure };
          m.aggregationsType = axe.aggregationsType;
          if (m.site_id == this.visualization.site_id) mesuresToLoad.push(m);
        }
      }
      let rows = [];
      let previousIntervalData = null; // ← Stockage de la valeur précédente
      //don't change that again !
      if (mesuresToLoad && mesuresToLoad.length > 0) {
        const result = await this.getMesuresData(
          startDate,
          endDate,
          interval,
          mesuresToLoad,
          this.filters,
          this.visualization.site_id,
          this.children_site_ids
        );
        rows = result.rows;
        previousIntervalData = result.previousData;

        console.log(rows);
      }
      if (updateId != this.updateId) {
        return;
      }

      let minDate;
      if (rows.length > 0) {
        if (interval && interval == "data") {
          minDate = toDate(rows[0]["@timestamp"]);
          /*let currentHours = minDate.getHours();
          let adjustedHours = currentHours + this.site['data_timeoffset'];
          if (adjustedHours < 0) {
              minDate.setDate(minDate.getDate() - 1);  // Move to the previous day
              adjustedHours = 24 + adjustedHours;  // Adjust hours to the 0-23 range
          }
          minDate.setHours(adjustedHours);*/
        } else {
          minDate = toDate(rows[0].key_as_string, dateFormatFrenchPretty);
          /*let currentHours = minDate.getHours();
          let adjustedHours = currentHours + this.site['data_timeoffset'];
          if (adjustedHours < 0) {
              minDate.setDate(minDate.getDate() - 1);  // Move to the previous day
              adjustedHours = 24 + adjustedHours;  // Adjust hours to the 0-23 range
          }
          minDate.setHours(adjustedHours);*/
        }
        if (!startDate && minDate) {
          startDate = minDate;
        }
      }
      let position = "left";

      for (let k in this.visualization.axes.axes) {
        let axe = this.visualization.axes.axes[k];
        if (histogramMode && !this.isHistogramAxis(axe)) {
          continue;
        }

        // console.log("axe", axe);
        if (!histogramMode && (!yearCompare || yearId == 0)) {
          let yAxe = {
            type: "linear",
            position: position,
            ticks: {
              color: axe.color.hex,
              textStrokeColor: axe.color.hex
            },
            display: (Object.hasOwnProperty(axe.display) ? true : axe.display)
          };

          if (axe.min && axe.min != null && axe.min != "") {
            yAxe.min = parseFloat(axe.min);
          }
          if (axe.max && axe.max != null && axe.max != "") {
            yAxe.max = parseFloat(axe.max);
          }
          this.chartOptions.scales[k] = yAxe;
        }
        let m = 0;
        for (let mesure of axe.mesures) {
          let color = axe.color.hex;
          let label = this.getMesureText(mesure);
          if (yearCompare && !this.uniqueYearCompare) {
            label += " " + this.yearCompareQuery.years[yearId];
            color = getAlteredColor(
                axe.color.hex,
                (yearId * 100) / this.yearCompareQuery.years.length
            );
          } else if(this.uniqueYearCompare && this.uniqueYearCompare === true){
            label += " " + "(" + ("P" + (yearId + 1)) + ")";
          }
          let dataset = {
            yAxisID: histogramMode ? "y" : k,
            label,
            borderColor: color,
            backgroundColor: color,
            borderWidth: 2,
            data: [],
            order: -1 * (100 * m + k)
            // order: -1 * (1000 * yearId + 100 * m + k),
          };

          let mesureRows = rows;

          if (mesure.site_id != this.visualization.site_id) {
            mesureRows = await this.getMesureData(
                startDate,
                endDate,
                interval,
                mesure.site_id,
                mesure
            );
            if (updateId != this.updateId) {
              return;
            }
            if (!mesureRows || mesureRows.length <= 0) {
              console.log("mesures empty for mesure : " + mesure);
              continue;
            }

            let minDate;

            if (interval && interval == "data") {
              minDate = toDate(mesureRows[0]["@timestamp"]);
            } else {
              minDate = toDate(mesureRows[0].key_as_string, dateFormatFrenchPretty);
            }
            if (!startDate && minDate) {
              startDate = minDate;
            }
          }

          let data;

          let values;
          if (interval != "data") {
            data = mesureRows.filter(
                (row) =>
                    row[mesure.csv_column] &&
                    row[mesure.csv_column].value != undefined &&
                    row[mesure.csv_column].value != null
            );
            values = data.map((row) => row[mesure.csv_column].value);
          } else {
            data = mesureRows.filter(
                (row) =>
                    row[mesure.csv_column] != undefined && row[mesure.csv_column] != null
            );

            values = data.map((row) => row[mesure.csv_column]);
          }
          this.min = Math.min(this.min, Math.min(...values));
          this.max = Math.max(this.max, Math.max(...values));

          //console.log(mesure);

          let datas = [];
          let times;
          if (yearCompare) {
            if (interval == "year") {
              times = [this.yearCompareQuery.years[yearId]];
            } else {
              times = data.filter((row) => {
                let timestr = row.key_as_string;
                let timedate = toDate(timestr);
                return timedate >= startDate && timedate <= endDate;
              });
              times = times.map((row) => {
                let timestr = row.key_as_string;
                return timestr.substring(0, timestr.length - 5);
              });
            }
          } else {
              const timeOffset = this.site['data_timeoffset']; // Get the time offset

            if (interval == "data") {
              times = data.map((row) => {
                let date = toDate(row["@timestamp"]); // Convert the string to Date object
                date.setHours(date.getHours() + timeOffset); // Add dynamic number of hours
                return convertDateToStringWithMinutes(date); // Return the formatted string
              });
            } else if(interval == "minute" || interval == "hour") {
                if(this.uniqueYearCompare && this.uniqueYearCompare == true){
                  let staticMonth = "01";
                  let fakeYear = null;

                  let uniqueDayMap = new Map();
                  let uniqueIndex = 1;
                  let oldDayStr = "";

                  times = data.map((row) => {
                    let [datePart, timePart] = row.key_as_string.split(' ');
                    let [day, month, year] = datePart.split('-');

                    // Crée l'objet Date initial AVANT TOUT
                    let originalDate = new Date(`${year}-${month}-${day}T${timePart}:00`);

                    // Applique le timeOffset d'abord
                    originalDate.setHours(originalDate.getHours() + timeOffset);

                    // Maintenant qu’on a la vraie date, on peut splitter pour le mapping
                    let adjustedDay = String(originalDate.getDate()).padStart(2, '0');
                    let adjustedMonth = String(originalDate.getMonth() + 1).padStart(2, '0');
                    let adjustedYear = originalDate.getFullYear();

                    const adjustedKey = `${adjustedDay}-${adjustedMonth}-${adjustedYear}`;
                    if (!uniqueDayMap.has(adjustedKey)) {
                        uniqueDayMap.set(adjustedKey, uniqueIndex++);
                    }

                    const dayStr = uniqueDayMap.get(adjustedKey).toString().padStart(2, '0');

                    //console.log(`dayStr = ${dayStr}`);

                    // On prend l’année de la première occurrence
                    if (fakeYear === null) fakeYear = year;

                    let date = new Date(`${fakeYear}-${staticMonth}-${dayStr}T${timePart}:00`); // Create Date object from the string

                    // Add the time offset to the date's hours
                    date.setHours(date.getHours() + timeOffset);

                    // Reconstruct the updated date and time back into the original format "DD-MM-YYYY HH:MM"
                    date.setDate(uniqueDayMap.get(adjustedKey));
                    let newDatePart = date.toLocaleDateString('en-GB'); // Format the date part as "DD-MM-YYYY"
                    let newTimePart = date.toTimeString().slice(0, 5); // Extract "HH:MM" from the time part

                    // Return the adjusted date and time in the format "DD-MM-YYYY HH:MM"
                    return `${newDatePart} ${newTimePart}`;
                  });
                  //console.log(JSON.stringify(times));
                } else {
                  times = data.map((row) => {
                      // Extract date and time from the row.key_as_string, which is in format "DD-MM-YYYY HH:MM"
                      let [datePart, timePart] = row.key_as_string.split(' '); // Split into date and time parts
                      let [hours, minutes] = timePart.split(':'); // Extract hours and minutes

                      // Convert datePart into a JavaScript Date object
                      let [day, month, year] = datePart.split('-'); // Split the date part (DD-MM-YYYY)
                      let date = new Date(`${year}-${month}-${day}T${timePart}:00`); // Create Date object from the string

                      // Add the time offset to the date's hours
                      date.setHours(date.getHours() + timeOffset);

                      // Reconstruct the updated date and time back into the original format "DD-MM-YYYY HH:MM"
                      let newDatePart = date.toLocaleDateString('en-GB'); // Format the date part as "DD-MM-YYYY"
                      let newTimePart = date.toTimeString().slice(0, 5); // Extract "HH:MM" from the time part

                      // Return the adjusted date and time in the format "DD-MM-YYYY HH:MM"
                      return `${newDatePart} ${newTimePart}`;
                  });
                }
              } else {
                  times = data.map((row) => row.key_as_string);
              }
          }

          //console.log(mesureRows);

          //Transform values of mesure by formula
          const formulaProcessor = createFormulaProcessor(mesure);
          const hasTemporalSensorConditions = (formulaProcessor.config?.rules || []).some(rule =>
              ['dateCompare', 'dateTimeCompare', 'timeCompare'].includes(rule.type));
          // Keep actual source dates, including the site offset, even in year comparisons.
          const formulaTimestamps = siteFormulaConfig || hasTemporalSensorConditions
              ? times.map((time, i) => getFormulaTimestamp(data[i], time, this.site.data_timeoffset))
              : null;

          if (previousIntervalData !== null && previousIntervalData !== undefined) {
            formulaProcessor.processor.state.previousInputValue = previousIntervalData[mesure.csv_column].value;
          }

          for (let i = 0; i < times.length; i++) {

            const result = formulaProcessor.process(values[i], hasTemporalSensorConditions ? formulaTimestamps[i] : times[i], datas);

            if (result.show) {
              datas.push({ x: times[i], y: this.roundDecimal(result.value, 3),
                ...(siteFormulaConfig ? { formulaTimestamp: formulaTimestamps[i] } : {}) });
            }
          }

          dataset.data = [... datas];
          dataset.unit = mesure.unit_of_measure;

          //console.log(JSON.stringify(dataset));

          if (m > 0) {
            dataset.borderDash = [m, m];
          }
          if (histogramMode && this.isHistogramAxis(axe)) {
            dataset.borderColor = getAlteredColor(axe.color.hex, m * 30);
            dataset.type = "bar";
            dataset.stack = "histogram";
          } else if (!yearCompare && this.isBarChart(axe)) {
            dataset.borderColor = getAlteredColor(axe.color.hex, m * 30);
            dataset.type = "bar";
          } else if (this.isLineChart(axe)) {
            dataset.showLine = true;
            //dataset.backgroundColor = (axe.color.hex.length === 8 ? axe.color.hex.substr(0,6) + '80' : axe.color.hex + '80');
            dataset.fill = false;
            dataset.type = "line";
            dataset.lineTension = 0.5;
          } else if (this.isRadarChart(axe)){
            dataset.type = "radar";
          }

          const aggType = axe.aggregationsType;
          const isMinMaxAgg = aggType === 'Min/Max' || aggType?.id === 'Min/Max' || aggType === 'min/max';

          if (isMinMaxAgg && !yearCompare && this.isLineChart(axe) && interval !== "data") {
            const minMaxDatasets = this.createMinMaxDataset(
                k,              // axeKey
                mesure,         // mesure config
                data,           // raw elastic data (contains _min and _max)
                times,          // formatted times
                interval,       // interval
                axe.color,      // axis color
                dataset.order,  // order
                formulaTimestamps,
                !!siteFormulaConfig
            );

            if (minMaxDatasets.length === 2) {
              this.chartData.datasets.push(minMaxDatasets[0]); // min
              this.chartData.datasets.push(minMaxDatasets[1]); // max
            }
          } else {
            this.chartData.datasets.push(dataset);
          }


          console.log(axe.hasOwnProperty("allowMinMaxAxes"));

          /*if (mesure.min && !yearCompare) {
            if(axe.hasOwnProperty("allowMinMaxAxes")) {
                if(axe.allowMinMaxAxes === true){
                    this.initHorizontalMin(k, startDate, endDate, mesure);
                }
            } else {
                this.initHorizontalMin(k, startDate, endDate, mesure);
            }
          }

          if (mesure.max && !yearCompare) {
            if(axe.hasOwnProperty("allowMinMaxAxes")) {
                if(axe.allowMinMaxAxes === true){
                    this.initHorizontalMax(k, startDate, endDate, mesure);
                }
            } else {
                this.initHorizontalMax(k, startDate, endDate, mesure);
            }
          }*/

          this.curveId++;
          m++;
        }
      }

      if (siteFormulaConfig) {
        // Only new datasets: comparison years already processed must not be transformed twice.
        applySiteFormula(this.chartData.datasets.slice(firstDatasetIndex), siteFormulaConfig,
            value => this.roundDecimal(value, 3));
      }

      if(this.site.calcForm != null && !siteFormulaConfig && !this.isHistogramChartVisualization()){

        let finalForm = this.removeSubstringBetweenSameChars(this.site.calcForm, "^");
        let readableFinalForm = "";
        let calcFormName = "Formule de calcul";

        if(Array.isArray(finalForm)){
          readableFinalForm = finalForm[1];
          calcFormName = finalForm[0];
        } else {
          readableFinalForm = finalForm;
        }

        let splitCalcForm = readableFinalForm.split(";");
        let filteredDataset = this.chartData.datasets.filter(item => item.label === splitCalcForm[0]);
        let newDataset = {
          "yAxisID":"calcFormAxe",
          "label": calcFormName,
          "borderColor":"#7A0313",
          "backgroundColor":"#7A0313",
          "borderWidth":2,
          "data":[],
          "order":(this.chartData.datasets[this.chartData.datasets.length-1].order) - 1,
          "showLine":true,
          "fill":false,
          "type":"line",
          "lineTension":0.5
        };

        for(let j = 0; j < filteredDataset[0].data.length; j++){
          let currentData = filteredDataset[0].data[j];
          let calcResult = 0
          for(let i = 0; i < splitCalcForm.length; i++){

            //console.log("--- debug CalcForm: " + i + " ---");

            if(splitCalcForm[i] !== "+" && splitCalcForm[i] !== "-" && splitCalcForm[i] !== "/" && splitCalcForm[i] !== "*"){

              let checkerValue = parseFloat(splitCalcForm[i])

              if(!isNaN(checkerValue)){
                switch(splitCalcForm[i-1]){
                  case "+":
                    calcResult = calcResult + checkerValue;
                    break;
                  case "-":
                    calcResult = calcResult - checkerValue;
                    break;
                  case "/":
                    calcResult = calcResult / checkerValue;
                    break;
                  case "*":
                    calcResult = calcResult * checkerValue;
                    break;
                }
              } else {
                for (let nextData of this.chartData.datasets.filter(item => item.label === splitCalcForm[i])) {
                  let valuesData = nextData.data.filter(item => item.x === currentData.x);
                  let currentValue = parseFloat(valuesData[0].y);

                  if (i === 0) {
                    calcResult = currentValue;
                  } else {
                    switch (splitCalcForm[i - 1]) {
                      case "+":
                        calcResult = calcResult + currentValue;
                        break;
                      case "-":
                        calcResult = calcResult - currentValue;
                        break;
                      case "/":
                        calcResult = calcResult / currentValue;
                        break;
                      case "*":
                        calcResult = calcResult * currentValue;
                        break;
                    }
                  }
                }
              }
            }
          }
          newDataset.data.push({"x": currentData.x, "y": calcResult});
        }
        this.chartData.datasets.push(newDataset);
      }

      let globalMin = Number.MAX_VALUE;
      let globalMax = -Number.MAX_VALUE;
      let hasUseGlobalMinMax = false;

      // 1️⃣ Parcourt tous les datasets pour trouver le min/max absolu
      for (let dataset of this.chartData.datasets) {
        const values = dataset.data
          .map((point) => (typeof point === "number" ? point : point && point.y))
          .filter((v) => v != null && Number.isFinite(v));

        if (values.length > 0) {
          globalMin = Math.min(globalMin, ...values);
          globalMax = Math.max(globalMax, ...values);
        }
      }

      globalMin = Math.floor(globalMin) + 5;
      globalMax = Math.floor(globalMax) + 5;

      // 2️⃣ Applique ce min/max global à tous les axes qui ont useGlobalMinMax: true
      for (let k in this.visualization.axes.axes) {
        let axe = this.visualization.axes.axes[k];

        // Skip si la propriété n'existe pas ou pas activée
        if (!axe.hasOwnProperty('useGlobalMinMax') || axe.useGlobalMinMax !== true) {
          continue;
        }

        hasUseGlobalMinMax = true;
        if (!this.chartOptions.scales[k]) {
          continue;
        }

        // Applique les min/max globaux
        if (globalMin !== Number.MAX_VALUE) {
          this.chartOptions.scales[k].min = globalMin;
        }
        if (globalMax !== -Number.MAX_VALUE) {
          this.chartOptions.scales[k].max = globalMax;
        }
      }

      this.delayed = false;
    },
    isBarChart(axe) {
      return axe.type == "Bars" || axe.type == "BarChart";
    },
    isHistogramAxis(axe) {
      return axe.type == "Histogram" || axe.type == "HistogramChart";
    },
    isLineChart(axe) {
      return axe.type == "Lignes" || axe.type == "LineChart";
    },
    isRadarChart(axe) {
      return axe.type == "Radar" || axe.type == "RadarChart";
    },

    initHorizontalMax(k, startDate, endDate, mesure) {
      this.max = Math.max(this.max, mesure.max);
      let maxDataset = {
        yAxisID: k,
        label: "Max " + mesure.csv_column,
        borderColor: "#F44336", //red
        data: [
          { x: convertDate(startDate), y: mesure.max },
          {
            x: convertDate(endDate),
            y: mesure.max,
          },
        ],
        type: "line",
        showLine: true,
        fill: false,
        pointRadius: 0,
      };
      this.chartData.datasets.push(maxDataset);
    },

    initHorizontalMin(k, startDate, endDate, mesure) {
      this.min = Math.min(this.min, mesure.min);
      let minDataset = {
        yAxisID: k,
        label: "Min " + mesure.csv_column,
        borderColor: "#00EDFF", //light blue
        data: [
          { x: convertDate(startDate), y: mesure.min },
          {
            x: convertDate(endDate),
            y: mesure.min,
          },
        ],
        type: "line",
        showLine: true,
        fill: false,
        pointRadius: 0,
      };
      this.chartData.datasets.push(minDataset);
    },

    initGraphicEventData(updateId, startDate, endDate, interval, yearCompare, yearId) {
      if (this.min == Number.MAX_VALUE) {
        this.min = 0;
      }
      if (this.max == -Number.MAX_VALUE) {
        this.max = 1;
      }
      let elasticQueryMust = buildQueryMust(
        this.visualization.site_id,
        this.children_site_ids,
        this.filters
      );
      let promise = new Promise((resolve, reject) => {
        let elasticQueryEvents = {
          from: 0,
          size: 1000,
          query: {
            bool: {
              must: elasticQueryMust,
            },
          },
        };

        this.$store
          .dispatch("elasticSearchRequest", {
            index: this.elastic_winery_events_index,
            site: this.visualization.site_id,
            body: elasticQueryEvents,
          })
          .then((result) => {
            if (updateId != this.updateId) {
              resolve();
            }
            let minDate = startDate;
            for (let hit of result.data.hits.hits) {
              let eventsData = hit._source;
              for (const [key, value] of Object.entries(eventsData)) {
                this.addGraphicEvent(
                  key,
                  value,
                  startDate,
                  endDate,
                  interval,
                  minDate,
                  yearCompare
                );
              }
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
      return promise;
    },

    initGraphicEventDataFormSaisiesPromise(
      updateId,
      startDate,
      endDate,
      interval,
      yearCompare,
      yearId
    ) {
      let promise = new Promise((resolve, reject) => {
        //READ events from mesures saisies
        let elasticQuery = buildTimeRangeQuery(
          startDate,
          endDate,
          null,
          this.visualization.site_id,
          ["events"],
          this.filters,
          this.children_site_ids,
          true
        );

        this.$store
          .dispatch("elasticSearchRequest", {
            index: this.elastic_winery_mesures_index,
            body: elasticQuery,
            size: 1000000,
            site: this.visualization.site_id,
          })
          .then((result) => {
            if (updateId != this.updateId) {
              resolve();
            }
            if (
              result.data &&
              result.data.hits &&
              result.data.hits.hits &&
              result.data.hits.hits.length > 0
            ) {
              let minDate = startDate;
              for (let hit of result.data.hits.hits) {
                let source = hit._source;
                if (source.events && source["@timestamp"]) {
                  for (let event of source.events) {
                    this.addGraphicEvent(
                      event,
                      source["@timestamp"],
                      startDate,
                      endDate,
                      interval,
                      minDate,
                      yearCompare
                    );
                  }
                }
              }
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
      return promise;
    },
    addGraphicEvent(key, value, startDate, endDate, interval, minDate, yearCompare) {
      if (!this.visualization.events.includes(key)) {
        return;
      }
      let valueDate = toDate(value);
      if (!valueDate) {
        return;
      }
      if (
        (startDate && startDate.getTime() > valueDate.getTime()) ||
        (endDate && endDate.getTime() < valueDate.getTime())
      ) {
        return;
      }
      if (!minDate || valueDate.getTime() < minDate.getTime()) {
        minDate = valueDate;
      }
      let date = value;
      if (interval != "hour" && interval != "minute" && interval != "data") {
        date = convertDate(valueDate);
      } else {
        date = convertDateToStringWithMinutes(valueDate);
        //TODO  elastic timestamp to dd-mm-yyyy hh:mm graphic label format !
      }

      let label = key;
      let borderColor = getColor(key);

      if (yearCompare) {
        date = convertDate(valueDate);
        label += " " + startDate.getFullYear();
        let year = this.dateYear(date);
        borderColor = getColor(year);
        date = this.dateWithoutYear(date);
      }

      let annotation = {
        type: "line",
        // id: "event" + this.eventIndex,
        // mode: "vertical",
        scaleID: "x",
        value: date,
        borderWidth: 3,
        borderColor,
        label: {
          content: convertDate(valueDate) + " : " + key,
          enabled: false,
          position: "top",
        },
        enter(context) {
          const element = context.element;
          element.options.label.enabled = true;
          context.chart.draw();
          // context.chart.canvas.style.cursor = "pointer";
        },
        leave(context) {
          const element = context.element;
          element.options.label.enabled = false;
          context.chart.draw();
          // context.chart.canvas.style.cursor = "initial";
        },
      };

      /*if (!this.chartOptions.plugins.annotation) {
        this.chartOptions.plugins.annotation = {
          annotations: [],
        };
      }*/
      this.chartOptions.plugins.annotation.annotations = {... this.chartOptions.plugins.annotation.annotations, annotation};

      this.eventIndex++;
    },

    setGraphicLabels(minDate, maxDate, interval, yearCompare) {
      let chartUnit = "minute";
      if (interval != "data") {
        chartUnit = interval;
      }
      if (
        interval != "data" &&
        this.visualization.events &&
        (interval == "month" || interval == "week")
      ) {
        chartUnit = "day";
      }
      let scales = this.chartOptions.scales;
      scales.x.type = "time";
      if (yearCompare) {
        let minD = Object.assign(minDate);
        let maxD = Object.assign(maxDate);
        minD.setFullYear(2000);
        maxD.setFullYear(2000);

        let parser = "DD-MM";
        scales.x.type = "category";
        if (interval == "year") {
          this.chartData.labels = [...this.yearCompareQuery.years];
        } else if (interval == "month") {
          this.chartData.labels = getDates(minD, maxD, interval).map((date) => {
            let datestr = convertDate(date);
            return this.dateWithoutYear(datestr);
          });
          // console.log(this.chartData.labels);
        } /*else if (interval == "minute" || interval == "hour") {
          const totalDays = getDates(minDate, maxDate, "").length;
          this.chartData.labels = Array.from({ length: totalDays }, (_, i) => `Jour ${i + 1}`);
        }*/ else {
          this.chartData.labels = getDates(minD, maxD, "").map((date) => {
            let datestr = convertDate(date);
            return this.dateWithoutYear(datestr);
          });
        }

        scales.x.time = {
          parser,
          unit: chartUnit,
          displayFormats: {
            year: "YYYY",
            month: "MMM",
            week: "DD-MM",
            day: "DD-MM",
          },
        };
      } else {
        if (interval == "minute" || interval == "hour") {
          if(this.uniqueYearCompare && this.uniqueYearCompare == true){
            minDate.setHours(0);
            minDate.setMinutes(0);

            maxDate.setHours(0);
            maxDate.setMinutes(0);

            scales.x.time = {
                parser: "DD-MM-YYYY HH:mm",
                unit: chartUnit,
                displayFormats: {
                  // year: "YYYY",
                  // month: "DD-MM-YYYY",
                  // week: "DD-MM-YYYY",
                  // day: "DD-MM-YYYY",
                  hour: "D, h A",
                  minute: "h:mm A",
                },
            };
            this.chartOptions.plugins.tooltip.callbacks = { ... this.chartOptions.plugins.tooltip.callbacks,
              title: function (tooltipItems) {
                const item = tooltipItems?.[0];
                const label = item?.label;

                if (!label) return '';

                // Exemple : "April 11, 2025 1:30:00 PM"
                const date = new Date(label);

                if (isNaN(date.getTime())) return label; // fallback si parsing échoue

                const day = date.getDate(); // 1 → 31
                const hours = date.getHours().toString().padStart(2, '0'); // 24h
                const minutes = date.getMinutes().toString().padStart(2, '0');

                return `Jour ${day} ${hours}h${minutes}`;
              }
            };
            let staticMonth = "01";
            let fakeYear = minDate.getFullYear(); // plus fiable

            let uniqueDayMap = new Map();
            let uniqueIndex = 1;

            let times = getDates(minDate, maxDate, interval).map((date) => {
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');

                // Clé unique par jour civil (ignore les heures/minutes)
                const dayKey = `${day}-${month}-${year}`;
                if (!uniqueDayMap.has(dayKey)) {
                    uniqueDayMap.set(dayKey, uniqueIndex++);
                }

                const fakeDay = uniqueDayMap.get(dayKey).toString().padStart(2, '0');

                // Construit une date valide (fakeDay-01-fakeYear HH:MM)
                return new Date(`${fakeYear}-${staticMonth}-${fakeDay}T${hours}:${minutes}:00`);
            });

            this.chartData.labels = times;
          } else {
            this.chartData.labels = getDates(minDate, maxDate, interval);
          }
        } else if (interval != "data") {
          this.chartData.labels = getDates(minDate, maxDate, interval).map((date) => {
            return convertDate(date);
          });
        }
      }
      if (!yearCompare)
        if(this.uniqueYearCompare && this.uniqueYearCompare == true){
          scales.x = {
              ...scales.x,
              min: this.chartData.labels[0],
              max: this.chartData.labels[this.chartData.labels.length - 1],
          };
        } else {
          scales.x = {
              ...scales.x,
              //min: convertDateToStringWithMinutes(minDate),
              //max: convertDateToStringWithMinutes(maxDate),
          };
        }

      // if (interval == "data") {
      //   // scales[0].ticks.source = "auto";
      // }
      scales.x.time.unit = chartUnit;
    },

    dateWithoutYear(datestr) {
      return datestr.substring(0, datestr.length - 5);
    },

    dateYear(datestr) {
      return datestr.substring(datestr.length - 4, datestr.length);
    },

    getNextColor() {
      this.colorIndex = (this.colorIndex + 1) % this.colors.length;
      return this.colors[this.colorIndex];
    },
    roundDecimal(nombre, precision = 2) {
      let tmp = Math.pow(10, precision);
      return Math.round(nombre * tmp) / tmp;
    },
    showErrEventDataLoading(err) {
      {
        if(this.$route.query.logging === "true"){
          let err2 = "Event data loading error : " + err;
          console.log(err2);
          if (this.$store.state.profile.user.role === 'Admin' || this.$store.state.profile.user.role === 'admin') {
            this.showErr(err2);
          }
        }
      }
    },
    showErrMesuresDataLoading(err) {
      {
        if(this.$route.query.logging === "true"){
          let err2 = "Mesure data loading error : " + err;
          console.log(err2);
          if (this.$store.state.profile.user.role === 'Admin' || this.$store.state.profile.user.role === 'admin') {
            this.showErr(err2);
          }
        }
      }
    },
    showErr(err) {
      {
        this.$store.commit("setSnack", {
          type: "red",
          msg: err,
        });
      }
    },
  },
};
</script>

<style scoped>
/* Keep Chart.js inside the available panel width, especially on mobile. */
.chart-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.chart-container ::v-deep canvas {
  max-width: 100% !important;
}

@media (max-width: 640px) {
  .chart-container {
    overflow: hidden;
  }
}
</style>
